<template>
  <v-container>
    <div>
      <template>
        <v-dialog v-model="dialog" width="876" persistent>
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ animalWeight.id ? this.$t('editCurrentRecord') : this.$t('addNewRecord') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-toolbar
              class="bdr secondary2light mt-4 ml-4"
              style="width: 80%"
              :elevation="0"
              outlined
              v-if="animalWeight.id"
            >
              <v-toolbar-title
                class="grey--text text--darken-2"
                style="font-size: 13px"
                >{{ $t('sureToEditRecord') }}
              </v-toolbar-title>
            </v-toolbar>
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="submit"
              style="padding: 20px"
            >
              <v-row>
                <v-col cols="6">
                  <label class="label">Average Daily Gain</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t(
                        "animal.performanceInfo.averageAmountWeightAnimalGainFeedingPeriod"
                      )
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="number"
                      outlined
                      dense
                      placeholder="e.g. 123"
                      v-model="animalWeight.averageDailyGain"
                    >
                    </v-text-field>
                    <v-select
                      :items="weights"
                      outlined
                      class="ml-4"
                      placeholder="Unit"
                      value="Kg"
                      dense
                      v-model="animalWeight.averageDailyGainUnit"
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">Liveweight (Current)</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceMenu.liveWeightTooltip")
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="number"
                      outlined
                      dense
                      placeholder="e.g. 123"
                      v-model="animalWeight.liveWeight"
                    ></v-text-field>
                    <v-select
                      :items="weights"
                      outlined
                      class="ml-4"
                      value="kg"
                      placeholder="Unit"
                      v-model="animalWeight.liveWeightUnit"
                      dense
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">Weaning Weight</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.weightAnimalMeasuredWeaning")
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="number"
                      outlined
                      dense
                      placeholder="e.g. 123"
                      v-model="animalWeight.weaningWeight"
                    ></v-text-field>
                    <v-select
                      :items="weights"
                      outlined
                      class="ml-4"
                      placeholder="Unit"
                      dense
                      v-model="animalWeight.weaningWeightUnit"
                    >
                    </v-select>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">Birth Weight</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.weightAnimalMeasuredBirth")
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="number"
                      outlined
                      dense
                      placeholder="e.g. 123"
                      v-model="animalWeight.birthWeight"
                    ></v-text-field>
                    <v-select
                      :items="weights"
                      outlined
                      class="ml-4"
                      placeholder="Unit"
                      dense
                      v-model="animalWeight.birthWeightUnit"
                    ></v-select>
                  </div>
                </v-col>
                <v-col cols="6">
                  <label class="label">Yearling Weight</label>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.weightYearOldAnimal")
                    }}</span>
                  </v-tooltip>
                  <div class="d-flex">
                    <v-text-field
                      :min="0"
                      type="number"
                      outlined
                      dense
                      placeholder="e.g. 123"
                      v-model="animalWeight.yearlingWeight"
                    ></v-text-field>
                    <v-select
                      :items="weights"
                      outlined
                      class="ml-4"
                      value="kg"
                      placeholder="Unit"
                      dense
                      v-model="animalWeight.yearlingWeightUnit"
                    >
                    </v-select>
                  </div>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-card-actions style="padding: 20px">
                <v-spacer></v-spacer>
                <v-btn
                  outlined
                  class="mr-2"
                  right
                  height="44"
                  width="116"
                  depressed
                  color="primary"
                  @click="closeModal"
                >
                  {{ $t("cancel") }}
                </v-btn>
                <v-btn
                  right
                  height="44"
                  width="116"
                  color="primary"
                  type="submit"
                >
                  {{ animalWeight.id ? $t("update") : $t("submit") }}
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </template>
    </div>
  </v-container>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";

export default {
  computed: {
    dialog() {
      return this.dialogI;
    },
    weights: () => ["kg", "lbs"],
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
    },
    submit() {
      if (!this.$refs.form.validate()) return;
      const mutation =
        this.animalWeight && this.animalWeight.id
          ? `mutation ($data: UpdateAnimalWeightRecordInput!) {
                    updateAnimalWeightRecord (updateAnimalWeightRecord: $data) {
                        id
                    }
                    }`
          : `mutation ($data: CreateAnimalWeightRecordInput!) {
                    createAnimalWeightRecord (createAnimalWeightRecord: $data) {
              id
            }
          }`;

      let payload = {
        animalId: Number(this.$route.params.animal_number),
        average_daily_gain: this.animalWeight.averageDailyGain
          ? Number(this.animalWeight.averageDailyGain)
          : null,
        average_daily_gain_unit: this.animalWeight.averageDailyGainUnit,
        weaning_weight: this.animalWeight.weaningWeight
          ? Number(this.animalWeight.weaningWeight)
          : null,
        weaning_weight_unit: this.animalWeight.weaningWeightUnit,
        birth_weight: this.animalWeight.birthWeight
          ? Number(this.animalWeight.birthWeight)
          : null,
        birth_weight_unit: this.animalWeight.birthWeightUnit,
        live_weight: this.animalWeight.liveWeight
          ? Number(this.animalWeight.liveWeight)
          : null,
        live_weight_unit: this.animalWeight.liveWeightUnit,
        yearling_weight: this.animalWeight.yearlingWeight
          ? Number(this.animalWeight.yearlingWeight)
          : null,
        yearling_weight_unit: this.animalWeight.yearlingWeightUnit,
      };

      if (this.animalWeight.id) {
        payload.id = parseInt(this.animalWeight.id);
      }
      this.$apollo
        .mutate({
          mutation: gql`
            ${mutation}
          `,
          variables: {
            data: payload,
          },
        })
        .then((res) => {
          let msg = "added";

          if (this.animalWeight.id) {
            msg = "updated";
          }
          if (res.data) {
            this.$notify({
              title: `Animal Weight record ${msg} successfully`,
              text: res.message,
              type: "success",
              position: "top right",
            });

            this.$emit("onUpdate");
          } else {
            this.$notify({
              title: `Animal Weight Record Not ${msg}`,
              text: res.message,
              type: "error",
              position: "top right",
            });
          }
          this.closeModal();
        })
        .catch((err) => {
          console.log(err.data);
          this.closeModal();
        });
    },
  },
  data() {
    return {
      animalWeight: {
        id: null,
        averageDailyGain: null,
        averageDailyGainUnit: null,
        weaningWeight: null,
        weaningWeightUnit: null,
        birthWeight: null,
        birthWeightUnit: null,
        liveWeight: null,
        liveWeightUnit: null,
        yearlingWeight: null,
        yearlingWeightUnit: null,
      },
      valid: true,
    };
  },
  mounted() {
    if (this.animalWeightItem) {
      this.animalWeight.id = this.animalWeightItem.id;
      this.animalWeight.averageDailyGain =
        this.animalWeightItem.averageDailyGain;
      this.animalWeight.averageDailyGainUnit =
        this.animalWeightItem.averageDailyGainUnit;
      this.animalWeight.weaningWeight = this.animalWeightItem.weaningWeight;
      this.animalWeight.weaningWeightUnit =
        this.animalWeightItem.weaningWeightUnit;
      this.animalWeight.birthWeight = this.animalWeightItem.birthWeight;
      this.animalWeight.birthWeightUnit = this.animalWeightItem.birthWeightUnit;
      this.animalWeight.liveWeight = this.animalWeightItem.liveWeight;
      this.animalWeight.liveWeightUnit = this.animalWeightItem.liveWeightUnit;
      this.animalWeight.yearlingWeight = this.animalWeightItem.yearlingWeight;
      this.animalWeight.yearlingWeightUnit =
        this.animalWeightItem.yearlingWeightUnit;
    }
  },
  props: ["dialogI", "animalWeightItem"],
  mixins: [loadingMixin],
};
</script>

<style scoped></style>
